import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiTrayArrowUp, mdiCellphone, mdiShimmer } from "@mdi/js";
import "./howItWorksModal.css";

const HowItWorksModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="how-it-works-modal-wrapper"
    >
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border" closeButton>
          <Modal.Title>How Smart Template Works</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-1 px-2">
          <div className="d-flex flex-column gap-4 p-0">
            {/* Create Template Section */}
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiTrayArrowUp}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <h5>Create Template</h5>
                <p>
                  Import Spectora XLS files to create templates.
                  <br />
                  The system automatically extracts sections and adds narratives
                  to your library.
                </p>
              </div>
            </div>

            {/* Using Templates Section */}
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiCellphone}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <h5>Using Templates in the Mobile App</h5>
                <p>
                  Choose a template when starting a project.
                  <br />
                  AI will automatically organize your notes into the right
                  sections.
                </p>
              </div>
            </div>

            {/* AI Narrative Enhancement Section */}
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center justify-content-center">
                <Icon
                  path={mdiShimmer}
                  size={1}
                  className="text-primary mt-1"
                />
              </div>
              <div>
                <h5>AI Narrative Enhancement</h5>
                <p>
                  AI references your narrative library to generate accurate and
                  professional results from your notes and photos.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onHide}>
            Got it
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default HowItWorksModal;
